import { render, staticRenderFns } from "./CkEditorPersonalizado.vue?vue&type=template&id=ffb3e848&"
import script from "./CkEditorPersonalizado.vue?vue&type=script&lang=js&"
export * from "./CkEditorPersonalizado.vue?vue&type=script&lang=js&"
import style0 from "./CkEditorPersonalizado.vue?vue&type=style&index=0&id=ffb3e848&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports